import { createSelector } from 'reselect';
import { RootState } from '../types';

import { FiberWaitListState, initialFiberWaitListState } from './types';

export const selectFiberWaitListDomain: (state: RootState) => FiberWaitListState = (state) => {
  return state?.fiberWaitList || initialFiberWaitListState;
};

export const selectWaitlistInformation = createSelector([selectFiberWaitListDomain], (state: FiberWaitListState) => ({
  firstName: state.firstName.value,
  lastName: state.lastName.value,
  email: state.email.value,
  phone: state.phone.value,
}));

export const selectIsWaitlistLoading = createSelector(
  [selectFiberWaitListDomain],
  (state: FiberWaitListState) => state.isWaitlistLoading,
);

export const selectIsWaitlistRequestComplete = createSelector(
  [selectFiberWaitListDomain],
  (state: FiberWaitListState) => state.isWaitlistRequestComplete,
);

export const selectFirstName = createSelector(
  [selectFiberWaitListDomain],
  (state: FiberWaitListState) => state.firstName,
);

export const selectLastName = createSelector(
  [selectFiberWaitListDomain],
  (state: FiberWaitListState) => state.lastName,
);

export const selectEmail = createSelector([selectFiberWaitListDomain], (state: FiberWaitListState) => state.email);

export const selectPhone = createSelector([selectFiberWaitListDomain], (state: FiberWaitListState) => state.phone);

export const selectIsWaitlistButtonDisabled = createSelector(
  [selectFiberWaitListDomain],
  (state: FiberWaitListState) => {
    const requiredFieldsValid = state.firstName.valid && state.lastName.valid && state.email.valid;

    const phoneValid = !state.phone.value || state.phone.valid;
    return !(requiredFieldsValid && phoneValid);
  },
);
